import { gql } from '@apollo/client';

export default gql`
  mutation ResetPassword($input: resetPasswordInput!) {
    resetPassword(input: $input)
  }
`;
